<template>
  <div class="slider-wrap">
    <a-slider
      v-bind="instance"
      v-model="sliderValue"
      range
      :min="min"
      :max="max"
      :step="step"
      :disabled="disabledSlider"
      :tooltipVisible="false"
      @afterChange="afterChange"
      @change="onChange"/>
    <p class="slider-text">{{_getSliderText()}}</p>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    instance: Object
  },
  data() {
    return {
      sliderValue: [0, 6],
      recordValue: [], // 记录上次的滑块值
      max: 6,
      min: 0,
      step: 1,
      disabledSlider: false,
      tipsText: '' // 用于单独处理结果
    }
  },
  created() {
    const { defaultValue } = this.instance
    this.sliderValue = defaultValue
    Object.assign(this, { ...this.instance })
  },
  watch: {
    getFilterAndExcludeExp: {
      handler(nVal) {
        const { name } = this.instance
        this.disabledSlider = nVal.indexOf(name) !== -1
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters('filterGroup', [
      'getFilterAndExcludeExp'
    ])
  },
  methods: {
    ...mapMutations('filterGroup', [
      'updateTempFilterItem'
    ]),
    handlerCustomValue() {
      const { name } = this.instance
      const { tipsText } = this
      const result = []
      if (tipsText === '0-最大') return
      if (tipsText.indexOf('-') !== -1) {
        const [start, end] = tipsText.split('-')
        result.push(`${name} >= ${start}`)
        result.push(`${name} <= ${end}`)
      } else {
        result.push(`${name}${tipsText}`)
      }
      return result
    },
    afterChange(value) {
      const { name, key } = this.instance
      const customValue = this.handlerCustomValue(value)
      const params = {
        isCustomDeal: true, // 表示已经是单独处理完成的检索式
        label: name,
        key,
        customValue,
        value
      }
      this.updateTempFilterItem(params)
      this.$emit('sliderUpdate', { item: this.instance, value })
    },
    onChange(value) {
      const result = this.handlerOverLep(value)
      this.sliderValue = result
      this.recordValue = result
    },
    handlerOverLep(value) {
      const { step, min, max } = this
      const [start, end] = this.recordValue
      const [curStart, curEnd] = value
      const result = new Array(2)
      if (curStart === curEnd) {
        const changePoint = start === curStart ? 'right' : 'left'
        if (changePoint === 'left') {
          const isOverLep = curEnd + step > max
          result[0] = isOverLep ? start : curStart + step // 如果重叠了，那就让右边的点又移一步
          result[1] = isOverLep ? end : curEnd + step
        } else {
          const isOverLep = curStart - step < min
          result[0] = isOverLep ? start : curStart - step
          result[1] = isOverLep ? end : curEnd - step
        }
      } else {
        result[0] = curStart
        result[1] = curEnd
      }
      return result
    },
    _getSliderText() {
      const value = this.sliderValue.length > 0 ? this.sliderValue : this.defaultValue
      const [start, end] = value
      let text = ''
      const obj = {
        0: 0,
        1: 1,
        2: 5,
        3: 10,
        4: 20,
        5: 50
      }
      if (end === 6) {
        text = `>${obj[start]}`
      }
      if (start === 0) {
        text = `<=${obj[end]}`
      }
      if (start > 0 && end < 6) {
        text = `${obj[start]}-${obj[end]}`
      }
      if (start === 0 && end === 6) {
        text = '0-最大'
      }
      this.tipsText = text
      return text
    }
  }
}
</script>
